/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

// ASSETS
import './RepresentativeNotesForm.scss'

class RepresentativeNotesForm extends Component {
  checkValidation = () => {
    const { formState } = this.props

    if (
      parseInt(formState.representative_id, 10) !== -1 &&
      formState.contact_made !== 'unselected' &&
      parseInt(formState.status_id, 10) !== -1 &&
      formState.note !== '' &&
      formState.note_type !== 'unselected'
    ) {
      return false
    }
    return true
  }

  displayRepresentatives = () => {
    const { representatives } = this.props

    if (representatives && representatives.length > 0) {
      return representatives.map(rep => (
        <option value={rep.id} key={rep.id}>
          {rep.first_name} {rep.last_name}
        </option>
      ))
    }
    return null
  }

  displayRepresentativeActionTypes = () => {
    const { representativeActionTypes } = this.props

    if (representativeActionTypes && representativeActionTypes.length > 0) {
      return representativeActionTypes.map(rep => (
        <option value={rep.id} key={rep.id}>
          {rep.name}
        </option>
      ))
    }
    return null
  }

  render() {
    const {
      formState,
      handleInputChange,
      toggleFormSection,
      createNote,
      updateNote,
      loader,
      isEdit,
      t,
    } = this.props
    const submitLabelKey = isEdit
      ? loader
        ? 'communities.notes.updatingNote'
        : 'communities.notes.updateNote'
      : loader
        ? 'communities.notes.addingNote'
        : 'communities.notes.addNote'
    return (
      <div id='RepresentativeNotesForm' className='animated fadeIn'>
        <div className='rep-form-header'>
          <h4>
            {isEdit
              ? t('communities.notes.editHeading')
              : t('communities.notes.createHeading')}
          </h4>
          <div>
            <button
              className='btn btn-primary'
              onClick={isEdit ? () => updateNote() : () => createNote()}
              disabled={loader || this.checkValidation()}
            >
              {loader && (
                <i className='fa fa-spinner fa-spin light-loading-spinner' />
              )}
              {t(submitLabelKey)}
            </button>
            <button
              className='btn-dark-link'
              onClick={() => toggleFormSection('notes')}
              disabled={loader}
            >
              {t('common.cancel')}
            </button>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-6'>
            <div className='row'>
              <div className='col-6'>
                <label>
                  {t('communities.notes.currentRepresentativeLabel')}{' '}
                  <span className='required-text'>*</span>
                </label>
                <select
                  className='form-control'
                  id='representative_id'
                  name='representative_id'
                  onChange={handleInputChange}
                  value={formState.representative_id}
                  disabled={loader}
                >
                  <option value={-1} disabled>
                    {t('communities.notes.chooseCurrentRepresentative')}
                  </option>
                  {this.displayRepresentatives()}
                </select>
              </div>
              <div className='col-6'>
                <label>
                  {t('communities.notes.wasContactMadeLabel')}{' '}
                  <span className='required-text'>*</span>
                </label>
                <select
                  className='form-control'
                  id='contact_made'
                  name='contact_made'
                  onChange={handleInputChange}
                  value={formState.contact_made}
                  disabled={loader}
                >
                  <option value={'unselected'} disabled>
                    {t('communities.notes.chooseAnswer')}
                  </option>
                  <option value={true}>{t('common.yes')}</option>
                  <option value={false}>{t('common.no')}</option>
                </select>
              </div>
            </div>

            <div className='row mt-3'>
              <div className='col-6'>
                <label>
                  {t('communities.notes.noteTypeLabel')}{' '}
                  <span className='required-text'>*</span>
                </label>
                <select
                  className='form-control'
                  id='note_type'
                  name='note_type'
                  onChange={handleInputChange}
                  value={formState.note_type}
                  disabled={loader}
                >
                  <option value={'unselected'} disabled>
                    {t('communities.notes.chooseNoteType')}
                  </option>
                  <option value={'Check In'}>
                    {t('communities.notes.noteType.checkIn')}
                  </option>
                  <option value={'Recap'}>
                    {t('communities.notes.noteType.recap')}
                  </option>
                  <option value={'Support'}>
                    {t('communities.notes.noteType.support')}
                  </option>
                </select>
              </div>
              <div className='col-6'>
                <label>
                  {t('communities.notes.actionTypeLabel')}{' '}
                  <span className='required-text'>*</span>
                </label>
                <select
                  className='form-control'
                  id='status_id'
                  name='status_id'
                  onChange={handleInputChange}
                  value={formState.status_id}
                  disabled={loader}
                >
                  <option value={'-1'} disabled>
                    {t('communities.notes.chooseAStatus')}
                  </option>
                  {this.displayRepresentativeActionTypes()}
                </select>
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <label>{t('communities.notes.representativeNotesLabel')}</label>
            <textarea
              name='note'
              type='text'
              className='form-control'
              rows='5'
              label=''
              onChange={handleInputChange}
              placeholder={t('communities.notes.notesPlaceholder')}
              value={formState.note}
              disabled={loader}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(RepresentativeNotesForm)
